import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Sayfa adresi (URL) her değiştiğinde ekranı en tepeye sar
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // Ekrana bir şey çizmez, sadece arkada çalışır
}